import { TUTORIAL_PREFIX } from '../actionTypePrefixes';
import { addActionTypePrefix } from '../util/addActionTypePrefix';

export const INIT = addActionTypePrefix('INIT', TUTORIAL_PREFIX);
export const init = (tutorialDocument) => ({
   type: INIT,
   tutorialDocument,
});

export const ADVANCE_TUTORIAL = addActionTypePrefix(
   'ADVANCE_TUTORIAL',
   TUTORIAL_PREFIX
);
export const advanceTutorial = () => ({
   type: ADVANCE_TUTORIAL,
});

export const TRIGGER_ACTIONS = addActionTypePrefix(
   'TRIGGER_ACTIONS',
   TUTORIAL_PREFIX
);
export const triggerActions = (actions) => ({
   type: TRIGGER_ACTIONS,
   actions,
});

export const AWAIT_MATCHED_ACTIONS = addActionTypePrefix(
   'AWAIT_MATCHED_ACTIONS',
   TUTORIAL_PREFIX
);
export const awaitMatchedActions = (actions) => ({
   type: AWAIT_MATCHED_ACTIONS,
   actions,
});

export const AWAIT_MATCHED_STATE = addActionTypePrefix(
   'AWAIT_MATCHED_STATE',
   TUTORIAL_PREFIX
);
export const awaitMatchedState = (requiredState) => ({
   type: AWAIT_MATCHED_STATE,
   requiredState,
});

export const START_SKIP_TIMER = addActionTypePrefix(
   'START_SKIP_TIMER',
   TUTORIAL_PREFIX
);
export const startSkipTimer = (canSkip) => ({
   type: START_SKIP_TIMER,
   canSkip,
});

export const SET_ALLOW_SKIP = addActionTypePrefix(
   'SET_ALLOW_SKIP',
   TUTORIAL_PREFIX
);
export const setAllowSkip = (allowSkip) => ({
   type: SET_ALLOW_SKIP,
   allowSkip,
});

export const COMPLETE_TUTORIAL_STEP = addActionTypePrefix(
   'COMPLETE_TUTORIAL_STEP',
   TUTORIAL_PREFIX
);
export const completeTutorialStep = () => ({
   type: COMPLETE_TUTORIAL_STEP,
});

export const COMPLETE_TUTORIAL = addActionTypePrefix(
   'COMPLETE_TUTORIAL',
   TUTORIAL_PREFIX
);
export const completeTutorial = () => ({
   type: COMPLETE_TUTORIAL,
});

export const SUBMIT_QUIZ_ANSWER = addActionTypePrefix(
   'SUBMIT_QUIZ_ANSWER',
   TUTORIAL_PREFIX
);
export const submitQuizAnswer = () => ({
   type: SUBMIT_QUIZ_ANSWER,
});

export const SET_QUIZ_ANSWER_CORRECT = addActionTypePrefix(
   'SET_QUIZ_ANSWER_CORRECT',
   TUTORIAL_PREFIX
);
export const setQuizAnswerCorrect = (quizAnswerCorrect) => ({
   type: SET_QUIZ_ANSWER_CORRECT,
   quizAnswerCorrect,
});

export const CANCEL_USER_ACTION = addActionTypePrefix(
   'CANCEL_USER_ACTION',
   TUTORIAL_PREFIX
);
export const cancelUserAction = () => ({
   type: CANCEL_USER_ACTION,
});
